import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseSupplierOrder() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validateEdit(state, setter) {
    let errorState = {
      productCount:
        isEmpty(state.productCount) ||
        state.productCount == 0 ||
        state.productCount == "0",
    };

    setter(errorState);

    if (errorState.productCount) {
      enqueueSnackbar("لطفا اطلاعات سفارش را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  function validate(state, setter) {
    let errorState = {
      productCount:
        isEmpty(state.productCount) ||
        state.productCount == 0 ||
        state.productCount == "0",
      productID: isEmpty(state.productID),
      supplierID: isEmpty(state.supplierID),
    };

    setter(errorState);

    if (
      errorState.productCount ||
      errorState.productID ||
      errorState.supplierID
    ) {
      enqueueSnackbar("لطفا اطلاعات سفارش را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getOrderList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_SupplierOrders?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllOrderList = (callback) => {
    MyAxios.get(`Admin_SupplierOrders?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getOrderByID = (id, callback) => {
    MyAxios.get(`Admin_SupplierOrders/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateOrderWarehouse = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_SupplierOrders/warehouse`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("سفارش با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  const updateOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_SupplierOrders`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("سفارش با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_SupplierOrders`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("سفارش با موفقیت ثبت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const cancelOrder = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_SupplierOrders`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("سفارش با موفقیت کنسل شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const sendSMS = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_SupplierOrders/SMS`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت ارسال شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getOrderList,
    getAllOrderList,
    getOrderByID,
    validate,
    addOrder,
    updateOrder,
    cancelOrder,
    validateEdit,
    updateOrderWarehouse,
    sendSMS,
  };
}
